<template>
    <div class="quantity-container">
        <div class="common quantity-button minus" @click="incrementQuantity(-1)">-</div>
        <input @change="setQuantity" class="common inputBox" :value="modelValue"/>
        <div class="common quantity-button plus"  @click="incrementQuantity(1)">+</div>
    </div>
</template>

<script>
export default{
    emits:['update:modelValue'],
    methods:{
        incrementQuantity(increment)
        {
            let newQuantity = Math.min(Math.max(this.modelValue+increment, this.min), this.max)

            this.$emit('update:modelValue',newQuantity)
        },
        setQuantity(e)
        {
            let value = parseInt(e.srcElement.value)
            let newQuantity = Math.min(Math.max(value, this.min), this.max)
            this.$emit('update:modelValue',newQuantity)
        }
    },
    props:{
        max:{
            type:Number,
            default:1
        },
        min:{
            type:Number,
            default:1
        },
        modelValue:{
            type:Number,
            default:1
        }

    }
}
</script>

<style scoped>
    .quantity-container{
        display: flex;
        height: 30px;
    }

    .inputBox{
        width: 50px;
    }

    .common{
        border: solid 1px lightgrey;
    }
    .quantity-button{
        width: 20px;
        text-align: center;
        background-color: whitesmoke;
        user-select: none;
    }

    .quantity-button:hover{
        background-color: lightgray;
        cursor: pointer;
    }

    .minus{
        border-top-left-radius: 4px;
        border-bottom-left-radius: 4px;
    }

    .plus{
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
    }

</style>